<template>
  <div class="content">
    <div class="card">
      <div class="address-detail">
        <div class="address-detail-con">
          <textarea placeholder="如需备注请输入" v-model="remark"></textarea>
        </div>
      </div>
    </div>
    <button class="save-btn" @click="saveremark">保存</button>
  </div>
</template>
<script>

export default {
  data () {
    return {
      remark: ''
    }
  },
  methods: {
    saveremark () {
      sessionStorage.setItem('remark', this.remark)
      this.$router.back(-1)
    }
  },
  mounted () {
    let remark = sessionStorage.remark
    if (remark) {
      this.remark = remark
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 .3rem;
  background: #f5f5f5;
  .card {
    background: #fff;
    border-radius: .16rem;
    margin-top: .3rem;
    .address-detail {
      padding: .3rem;
      .address-detail-title {
        border-top: 1px solid #ebebeb;
        font-size: .28rem;
        line-height: .8rem;
      }
      .address-detail-con {
        textarea {
          resize:none;
          width: 100%;
          height: 3rem;
          outline: none;
          font-size: .28rem;
        }
      }
    }
  }
}
.save-btn {
  width: 6.90rem;
  height: .90rem;
  background: rgba(2, 179, 137, 1);
  border-radius: .45rem;
  margin-top: .3rem;
  color: #fff;
  font-size: .32rem;
}
.address {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 .3rem;
  box-sizing: border-box;
  z-index: 99;
  background:#fff;
}
.title {
  display: -webkit-flex;
  align-items: center;
}
.title span {
  flex: 1;
  text-align: right;
  font-size: 0.45rem;
  color :#D8D8D8;
}
.title h4 {
  flex: 3;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.88rem;
  font-weight: normal;
}
.area {
  display: inline-block;
  font-size: 0.24rem;
  line-height: 2;
  margin-right: 0.42rem;
  vertical-align: middle;
}
.address-list {
  margin-top: .2rem;
  padding-bottom: .2rem;
}
.addList {
  margin-top: .14rem;
  width: 100%;
  font-size: 0.30rem;
  line-height: 2;
}
/* 修改的格式 */
.address ul{
  width: 95%;
  height: 4rem;
  overflow-y: auto;
}

.address .title .active{
  color:#0071B8;
  border-bottom:0.02rem solid #0071B8;
}
.address ul .active{
  color:#0071B8;
}
</style>



// WEBPACK FOOTER //
// src/pages/buyRemark/buyRemark.vue